module.exports = __webpack_public_path__ + "images/embalagens.png?7cfa5ccf27036ab802b40b3ec0b22d25";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/embalagens.png
// module id = 977
// module chunks = 0